import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types.js';
const themeSetting = {
    theme: Theme.Rocketbet,
    rankConfig: {
        sublevelFormat: 'named_numeric',
        sublevelImages: true
    },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'rocketbet',
    brand: 'rocketbet.com',
    brandTitle: 'Rocketbet',
    canonicalUrl: 'https://rocketbet.com',
    cdnBase: 'https://cdn.rocketbet.com',
    cdnBaseFallbacks: ['https://rocket.gmcdn.org'],
    cdnTiles: 'https://tiles.rocketbet.com',
    cdnBanners: 'https://cdn.rocketbet.com/',
    cubePayEnabled: true,
    discordLink: '',
    facebookLink: 'https://www.facebook.com/rocketbetcasino',
    fingerprintjs: 'RRJpTry7JPqVq4qwU8TR',
    fingerprintjsHost: 'fp.rocketbet.com',
    fingerprintVersions: ['v3.9.7'],
    googleAnalytics: 'G-D3WV6FTW9V',
    googleClientId: '1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    googleTagManager: '',
    instagramLink: 'https://www.instagram.com/rocketbet_onlinecasino',
    languageDefault: 'en',
    languages: ['en', 'de', 'fr', 'ar'],
    topProvidersSlugs: [
        'pragmatic-play',
        'nolimit-city',
        'hacksaw-gaming',
        'rocketbet-originals',
        'pragmatic-play-live',
        'evolution',
        'bgaming',
        'play-n-go',
        'novomatic'
    ],
    languagesTiles: ['ja', 'ko'],
    languagesAutoAccept: ['en', 'ja', 'ko'],
    megajackpotFeed: {
        operator: 'ROCKETBET',
        hash: '559ad72779b9c9c151edd516a295204069f4b8938cfba1621f996ec9d17214a2',
        currency: 'USD'
    },
    intercomId: 'ht70ghtg',
    racesEnabled: false,
    supportEmail: 'support@rocketbet.com',
    telegramLink: 'https://t.me/+Zr6A6OTvsvJjYmJi',
    gameSetLimit: 30,
    newGamesIncludeLive: true,
    xLink: '',
    youtubeLink: '',
    noIndex: false,
    themePath: 'fomoio',
    verbiageLabel: 'fomoio',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'alternative2',
            showRewardsAndPromo: false,
            showSearch: true,
            itemOrder: ['menu', 'casino', 'sports', 'chat', 'search']
        },
        accordion: {
            accordionStyle: 'alternative2',
            accordionExpandedBackground: true
        },
        auth: {
            useSolidAccentOAuthButton: false,
            showWalletConnect: false,
            useTightModalBodyPadding: false,
            useOffsetModalCloseButton: true
        },
        background: {
            backgroundStyle: 'gradient-stars'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'alternative',
            buttonVariant: 'tertiary'
        },
        cardSwiper: {
            cardSwiperStyle: 'default',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: false
        },
        button: {
            buttonStyle: 'glass',
            usebuttonBackgroundImage: true,
            useUppercaseAsDefault: false
        },
        betby: {
            betslipBottom: 60,
            customUI: false
        },
        betfeed: {
            betfeedStyle: 'alternative2',
            usedVerbiage: 'live_wins'
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: true,
            withdrawOnlyUsdtMemeCoins: true,
            showConversionRateDeposit: false,
            showWiddrawalOnlyUSDT: false,
            showProgressBarBonusMoney: true,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 5000,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: true,
            depositBonusVerbiage: 'casino_deposit_bonus',
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'originals', percentage: 5 },
                { category: 'live_casino', percentage: 0 },
                { category: 'table_games', percentage: 0 }
            ],
            showWithdrawalWarningIfNoFunds: true,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'alternative2',
            useCashierHomeScreen: true,
            useSidetabs: false,
            buyCryptoEnabled: false,
            useCashierV4: false,
            useCompactDepositAddressOptionLayout: false,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useVerificationStep: true
        },
        casinoLobby: {
            casinoLobbyStyle: 'alternative2',
            showLiveWins: true,
            showBetFeed: true
        },
        chat: {
            chatStyle: 'alternative2',
            requiredLanguageVerbiage: 'english'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'alternative2'
        },
        dropdown: {
            dropdownStyle: 'alternative2',
            useDropdownBackgroundImage: false,
            useGlassDropdownPanel: true
        },
        emailVerify: {
            emailVerifyStyle: 'alternative2'
        },
        footer: {
            footerStyle: 'alternative2',
            useWideFooterMark: true,
            useLegalsMarkdownContent: true,
            footerLinksLayout: 'with_casino_sportsbook',
            useEmbeddedShellDecor: false
        },
        games: {
            showRacesLeaderboard: false,
            showNavigationOnMobile: false,
            showLikeButton: true,
            showLogoWhenPlayingDesktop: false,
            showGameInfoModalOnGamePathMobile: false,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false
        },
        header: {
            headerStyle: 'alternative2',
            buttonLoginVariant: 'secondary',
            useTightRewardsToggleHorizontalPadding: false,
            hideVipButtonOnLogout: true
        },
        helpdesk: {
            useDynamicBonusTerms: true,
            showDepositBonusTermsCta: true
        },
        home: {
            homeStyle: 'alternative2',
            showBuyCryptoBanner: true,
            showLiveWins: true,
            cryptoBannerStyle: 'alternative2',
            buyCryptoBannerArtStyle: 'orbit',
            showAdventCalendarPage: false
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: false,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoAccordion: {
            showProviderLink: true
        },
        infoCard: {
            infoCardStyle: 'radial-gradient-2'
        },
        input: {
            inputStyle: 'alternative2'
        },
        layout: {
            layoutStyle: 'default',
            isContrastTextColor: false,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: true,
            useCurrentColorSidebar: true,
            useReferralIconAnimated: false,
            useNewIcons: false,
            useRemoteIcons: true,
            showCryptoPriceDropdown: false,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useReferralBannerOnlyImageCustom: false,
            usePromoItemContentCustom: false,
            useCentralButtonOnMobileMenu: false,
            sectionIconSize: 20,
            useUppercaseSectionTitles: false,
            useExpandedRankPresentation: false,
            useAlternateMobileSidebarBackdrop: false,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'alternative3',
            usedVerbiage: 'big_wins',
            useSpecialWinCards: false
        },
        loading: {
            useLottie: true,
            publicInitPageLoadDisplayFor: 2750,
            playerInitPageLoadDisplayFor: 2750
        },
        maintenance: {
            maintenanceStyle: 'alternative2',
            contentSource: 'markdown'
        },
        geoblock: {
            contentSource: 'markdown'
        },
        modal: {
            modalStyle: 'glass'
        },
        walletDropdown: {
            showBalancePreferenceToggles: true,
            applyBackgroundBlur: true
        },
        notifications: {
            notificationsStyle: 'alternative2',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: false
        },
        toasts: {
            toastsStyle: 'alternative',
            isLocalIcon: false
        },
        profileModal: {
            profileModalStyle: 'alternative2',
            showFavouriteSection: true,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true
        },
        promotions: {
            showExpiredPromotions: true,
            useAspectRatioBoxDetailCustom: false,
            promoBannerStyle: 'alternative2',
            promotionsStyle: 'alternative2',
            showActionButton: true,
            promoCtasMatchLoggedInWhenLoggedOut: true
        },
        provider: {
            providerStyle: 'alternative2',
            useSolidPrimaryGameCountBadge: true
        },
        referral: {
            referralDashboardBannerType: 'html',
            showContainerInFAQ: false,
            faqTitleStyle: 'badge',
            faqVerbiageKeys: 'default',
            faqAboutPagePreset: 'rocket',
            faqVisibilityPreset: 'all',
            referralDashboardFaqVisibilityPreset: 'hide_getting_started',
            accordionGlassStyle: true,
            rulesCardsStyle: 'glass',
            commissionLevelsLayout: 'contained-panel',
            commissionLevelsTierBadgeAdjacentToPercentage: true,
            showCommissionLevelsCardBackground: true,
            rulesFootnoteMuted: true,
            highlightStepTitles: false,
            highlightReferralDashboardBannerTitle: false,
            rankProgressPalette: 'cool',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'basic',
            shareMessageVariant: 'default',
            shareBannerStyle: 'classic',
            referralDashboardBannerStyle: 'classic',
            showInviteBannerHatIllustration: false,
            inviteBannerImageFit: 'width',
            showAboutPageBackgroundImage: false,
            showAboutPageDecorativeGradients: false,
            alignInviteBannerTextStartOnMobile: true,
            useCompactInviteBannerMobileTypography: true,
            useInviteBannerGradientBorder: true,
            inviteBannerLoggedOutCta: 'register',
            aboutPageEarnAndStepsPresentation: 'combined-how-it-works-section',
            aboutPageHeroPresentation: 'expanded-hero-banner',
            useExpandedHeroCommissionTypography: true,
            useExpandedHeroLargeTitleTypography: true,
            useExpandedAboutPageSectionTitles: true,
            useTransparentAboutPageBackground: true
        },
        transparency: {
            enabled: true
        },
        affiliates: {
            enabled: true,
            usePrefixedVerbiageKeys: true,
            showPartnersTestimonials: false,
            showEarningsCardBackground: true,
            earningsCardBackgroundLayout: 'flow-top-half',
            useMainFontExtraboldTitles: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'alternative2',
            useComfortableRewardsTimerLabels: false,
            showSeasonalRewardsCampaignTabs: false
        },
        seoText: {
            style: 'default'
        },
        settings: {
            settingsStyle: 'alternative2',
            useIconsInTabs: true
        },
        sidebar: {
            sidebarStyle: 'alternative2',
            showLuckyDip: false,
            showBanner: true,
            bannerVariant: 'jackpot',
            bannerLink: '/promotion-page/jackpot',
            supportFullWidthMobile: true,
            useLiveSupportLabel: true,
            vipNavRowLabelVariant: 'alternate_vip_heading',
            tournamentsNavRowLabelVariant: 'alternate_tournaments_heading',
            vipBeforePromotions: true
        },
        table: {
            tableStyle: 'alternative2'
        },
        tabs: {
            tabsStyle: 'alternative2',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'primary'
        },
        text: {
            successTextUsesWarmTone: false
        },
        toggle: {
            toggleStyle: 'alternative2'
        },
        tooltip: {
            tooltipStyle: 'alternative'
        },
        topSection: {
            casinoTopSectionStyle: 'alternative2',
            buttonVariant: 'tertiary',
            useCampaignHero: true
        },
        transactions: {
            transactionsStyle: 'alternative',
            useInProgressForApprovingTxStatus: true,
            useSegmentedTabs: false,
            useElevatedRows: false,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'alternative2',
            vipAboutStyle: 'alternative2',
            vipAboutStylePreview: 'modern',
            useMarkdownFaqs: true,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'detailed',
            rewardsProgressPalette: 'cool',
            includeWageringRequirementRow: false,
            reorderPrimaryBenefitCards: false,
            testimonialsHeaderStyle: 'badge',
            useCompactTestimonialsCardHeight: false,
            faqListLength: 'full',
            usePrefixedVerbiageKeys: true,
            assetSet: 'elevated',
            negativeBadgeTone: 'coral',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useExpandedVipCalendarCardPadding: true,
            useGradientVipCalendarDateHeader: true,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent'
        },
        progressBar: {
            showProgressIcon: false
        },
        profileDropdown: {
            showSupport: true,
            profileDropdownStyle: 'default'
        }
    }
};
const themeSettings = [
    {
        ...themeSetting,
        brand: 'gamma.rocketbet.com',
        fingerprintjsHost: 'fp.rocketbet.com'
    },
    {
        ...themeSetting,
        brand: 'prod-rocketbet.previewenv.net'
    },
    {
        ...themeSetting,
        brand: 'alpha-rocketbet.previewenv.net'
    },
    {
        ...themeSetting,
        brand: 'localhost'
    }
];
export const getThemeSetting = (domain, fullDomain) => {
    const matched = themeSettings.find((s) => fullDomain.includes(s.brand)) ?? themeSetting;
    return matched.brand === 'localhost' ? { ...matched, brand: themeSetting.brand } : matched;
};
export const endpointSettings = [
    {
        name: 'rocketbet',
        theme: Theme.Rocketbet,
        base: 'monopoly-rocket.prod.infinitro.dev',
        baseCurrency: 'USD',
        baseCurrencySymbol: '$',
        baseCurrencyDigits: 2,
        betbyBrandId: '2640194147054657536',
        betbyEnabled: true,
        betbyScriptUrl: 'https://rocketbet.sptpub.com/bt-renderer.min.js',
        realm: 'prod-rocket',
        catalogFilter: CatalogFilter.AllGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
        gamityBrandRef: 'rocketbet',
        gamityCurrency: 'USDT',
        gamityEnvironment: 'production',
        integrationRef: 'visionlink-gametech-as'
    }
];
export const endpointSetting = (appMode, // eslint-disable-line @typescript-eslint/no-unused-vars
domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    return endpointSettings[0];
};
